import { useQuery } from "@tanstack/react-query"
import { GetNavigation } from "../api/queries"


export  const useNavigation =()=> {
    return useQuery({
        queryKey: ["SiteNavigation"],
        queryFn: ()=>GetNavigation("PrimaryNavigationV2"),
        staleTime: 60 * 1000 * 180,
        gcTime: 60 * 1000 * 180,
    })
}